import { clickTrack } from './tracking';
import { get, invert } from 'lodash';
import Partners from '../../lib/singletons/partners';
import { ROUTES, EXTERNAL_PARTNERS, ROUTE_TO_CATEGORY } from './constants';

// pass handler functions as props as well
const appHandler = (props, context) => {
  const {
    activeKey,
    tools,
    dispatch,
    updateTab,
    updateApp,
    updatePath,
    categories,
    toggleToolFavorite,
    history
  } = props;

  const getRoute = item =>
    Object.keys(ROUTES).find(route => ROUTES[route].includes(item));

  const setApp = (item, opts = {}) => {
    clickTrack(props, {
      link: opts.fptiLink || item
    });

    if (EXTERNAL_PARTNERS.includes(item)) {
      const partners = Partners.instance();
      const partner = partners[item] || {};
      dispatch((window.location.href = partner.link || '/mep/dashboard'));
    }

    let route = getRoute(item);

    if (route) {
      history.push(`/${route}/${item}`);
      dispatch(updatePath(item)); // update path with item
      window.scrollTo(0, 0); // scroll to top after route change
    } else {
      dispatch(updateApp(activeKey, item));
    }
  };

  const setTool = tool => {
    clickTrack(props, {
      link: tool
    });

    window.location.href = tools[tool].link;
  };

  const categoryToRoute = invert(ROUTE_TO_CATEGORY),
    categoryIndexes = get(props, 'categoryIndexes', {}),
    indexCategories = invert(categoryIndexes);

  const changeTab = key => {
    let category = indexCategories[key],
      path = categoryToRoute[category];

    clickTrack(props, {
      link: get(categories[key], 'name', 'favorite')
    });

    dispatch(updateTab(key));
    history.push(`/${path}`);
  };

  /**
   * Toggle the favorite flag of this tool.
   * tool object contain key which is the tool's name.
   * @param {object} tool
   */
  const toggleFavorite = (tool, search) => {
    const toolName = get(tool, 'key', ''),
      // the tool object passed to this function contains all the
      // current states of that tool including favorite.
      // so we need to revert that flag to get the next favorite state.
      enable = !get(tool, 'favorite', false);

    clickTrack(props, {
      link: `${enable ? 'favorited' : 'unfavorited'}_${toolName}`
    });

    dispatch(toggleToolFavorite(tool, search));
  };

  return {
    setApp: setApp.bind(context),
    setTool: setTool.bind(context),
    changeTab: changeTab.bind(context),
    toggleFavorite: toggleFavorite.bind(context)
  };
};

export { appHandler };
